export function underscoreToCamelCase(object: any): any {
  if (Array.isArray(object)) return object.map((v) => underscoreToCamelCase(v));
  if (object && typeof object === 'object') {
    const newObj: any = {};
    Object.keys(object).forEach((key) => {
      const formattedKey = key.replace(/_([a-z])/g, (_, ch) => ch.toUpperCase());
      newObj[formattedKey] = underscoreToCamelCase((object as any)[key]);
    });
    return newObj;
  }
  return object;
}
